/**
 * @generated SignedSource<<e97f79d7deca5a84d84007a3f260b8c6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarSoldItemsColumns_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumn_item" | "useDetailEntries_item" | "useShouldShowSimilarSoldItems_item">;
  readonly " $fragmentType": "PdpSharedSimilarSoldItemsColumns_item";
};
export type PdpSharedSimilarSoldItemsColumns_item$key = {
  readonly " $data"?: PdpSharedSimilarSoldItemsColumns_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumns_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarSoldItemsColumns_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "catchNonFatalErrors",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarSoldItemsColumn_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDetailEntries_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b11242bdbe7c2f935ccf6b91650100f2";

export default node;
